import React, { PureComponent, Fragment } from 'react';
import renderHTML from 'react-render-html';
import { Helmet } from "react-helmet";


// Components
import Header from 'components/header/header.component';

import BuyForm from 'components/buyForm/buyForm.component';
import {
  StyledBoostWrapper,
  StyledTextWrapper,
} from "./abonament.style";

import {
  StyledElementWrapper,
  StyledElementWrapperCenter,
  StyledElementHeaderTitle,
  StyledElementHeaderDescription
} from 'styledElements';


// Texts
import text from 'i18l';




class AbonamentComponent extends PureComponent {
  componentDidMount() {
    window.scrollTo(0,0);
    this.props.invoiceFormReset();
  }

    render() {
        const { buyFormRequest, buyFormSuccess, buyFormFailure } = this.props;

        return (
            <Fragment>
              <Helmet>
                <title>Oferta dla firm | Myjnia bezdotykowa Koło myjniakolo.pl</title>
                <meta name="description" content="Faktura VAT |Myjnia bezdotykowa Koło myjniakolo.pl" />
              </Helmet>
              <Header/>
              <StyledElementWrapper>
                <StyledElementWrapperCenter>
                  <header>
                    <StyledElementHeaderTitle>
                      {text.ABONAMENT.TITLE}
                    </StyledElementHeaderTitle>
                    <StyledElementHeaderDescription>
                      {text.ABONAMENT.DESCRIPTION}
                    </StyledElementHeaderDescription>
                  </header>
                  <StyledTextWrapper>
                      {renderHTML(text.ABONAMENT.TEXT)}
                  </StyledTextWrapper>
                </StyledElementWrapperCenter>
              </StyledElementWrapper>
                <BuyForm
                    buyFormRequest={buyFormRequest}
                    buyFormSuccess={buyFormSuccess}
                    buyFormFailure={buyFormFailure}
                />
              <StyledBoostWrapper>
                <StyledElementWrapperCenter>
                  <header>
                    <StyledElementHeaderTitle>
                      {text.ABONAMENT.BOOST_TITLE}
                    </StyledElementHeaderTitle>
                    <StyledElementHeaderDescription>
                      {text.ABONAMENT.BOOST_DESCRIPTION}
                    </StyledElementHeaderDescription>
                  </header>
                  <StyledTextWrapper>
                    {renderHTML(text.ABONAMENT.BOOST_TEXT)}
                  </StyledTextWrapper>
                </StyledElementWrapperCenter>
              </StyledBoostWrapper>
            </Fragment>
        );
    }
}

export default AbonamentComponent;



// WEBPACK FOOTER //
// ./src/routes/abonament/abonament.component.js